import { Component, EventEmitter, Output } from '@angular/core';
import { CommonAnimations } from '@shared/animations/common.animations';
import { ToothCrossService } from '@features/client/order-workflow/services/tooth-cross.service';
import { CrownAction } from '@features/client/order-workflow/enums/crown-action.enum';
import { ToothCrownAction } from '@features/client/order-workflow/models/tooth.model';
import { ModuleKeys } from '@core/enums/module-keys.enum';
import { Tooltip } from 'primeng/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-crown-actions',
  templateUrl: './crown-actions.component.html',
  styleUrls: ['./crown-actions.component.scss'],
  animations: [CommonAnimations.fadeIn],
  imports: [Tooltip, TranslatePipe],
})
export class CrownActionsComponent {
  @Output() public closeActions: EventEmitter<void> = new EventEmitter<void>();

  public isOpened: boolean = true;
  public actions: ToothCrownAction[] = [
    {
      icon: 'fas fa-plus',
      tooltip: `${ModuleKeys.dental}.crown_add_product.label`,
      action: CrownAction.add,
    },
    {
      icon: 'fas fa-pencil',
      tooltip: `${ModuleKeys.dental}.crown_configure_product.label`,
      action: CrownAction.configure,
    },
  ];

  constructor(private readonly toothCrossService: ToothCrossService) {}

  public handleActionClick(action: CrownAction): void {
    setTimeout(() => {
      return this.toothCrossService.setCrownAction(action);
    });
  }
}
